import bannerImage from "../assets/image-1.jpg";
import livingImage from "../assets/GH-Rajapur.jpg";
import amenitiesImage from "../assets/GH–HealthVillage.jpg";
import viewImage from "../assets/GH-Sadasivapet.jpg";
import lifestyleImage from "../assets/DV-Shadnagar.png";
import livingImage2 from "../assets/AA-Yadadri.png";
import { FaLocationArrow, FaGem, FaChartLine, FaLeaf } from "react-icons/fa";
import gallery1 from "../assets/Gallery4.jpg";
import gallery2 from "../assets/Gallery7.jpg";
import gallery3 from "../assets/DV-Shadnagar.png";
import gallery4 from "../assets/Gallery1.jpg";
import gallery5 from "../assets/Gallery8.jpg";
import gallery6 from "../assets/Gallery9.jpg";
import { useNavigate } from "react-router-dom";
import strength1 from "../assets/awardwinning.png";
import strength2 from "../assets/hmtv.avif";
import strength3 from "../assets/EconomicTimes.png";
import strength4 from "../assets/Trusted-by.png";
import strength5 from "../assets/ISO.png";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import man1 from "../assets/Testimonials-1.jpg";
import man2 from "../assets/Testimonials-2.jpg";
import woman1 from "../assets/Testimonials-3.jpg";
import woman2 from "../assets/Testimonials-4.jpg";
import heroVideo from "../assets/RameshProperty.mp4"; // update path
import { useState } from "react";
import { FaComments, FaPhoneAlt } from "react-icons/fa";
import {
  submitToGoogleSheets,
  validateFormData,
  isValidEmail,
  isValidPhone,
} from "../utils/googleSheets";

const Home = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Floating buttons state
  const [showFloatingButtons, setShowFloatingButtons] = useState(false);

  // Popup form state
  const [showPopup, setShowPopup] = useState(false);
  const [popupFormData, setPopupFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [popupLoading, setPopupLoading] = useState(false);
  const [popupFeedback, setPopupFeedback] = useState({ type: "", message: "" });

  // Schedule visit form state
  const [scheduleFormData, setScheduleFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    visitDate: "",
    timeSlot: "",
    requirements: "",
  });
  const [scheduleLoading, setScheduleLoading] = useState(false);
  const [scheduleFeedback, setScheduleFeedback] = useState({
    type: "",
    message: "",
  });

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  useEffect(() => {
    const hasSeen = localStorage.getItem("contactPopupSeen");
    if (!hasSeen) {
      const timer = setTimeout(() => {
        setShowPopup(true);
        localStorage.setItem("contactPopupSeen", "true");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, []);

  // Handle popup form input changes
  const handlePopupInputChange = (e) => {
    const { name, value } = e.target;
    setPopupFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle popup form submission
  const handlePopupSubmit = async (e) => {
    e.preventDefault();
    setPopupLoading(true);
    setPopupFeedback({ type: "", message: "" });

    // Validate required fields
    const { isValid, errors } = validateFormData(popupFormData, [
      "name",
      "email",
      "phone",
      "message",
    ]);

    if (
      !isValid ||
      !isValidEmail(popupFormData.email) ||
      !isValidPhone(popupFormData.phone)
    ) {
      setPopupFeedback({
        type: "error",
        message:
          "Please fill all fields correctly (valid email & 10-digit phone)",
      });
      setPopupLoading(false);
      return;
    }

    try {
      const result = await submitToGoogleSheets(
        {
          name: popupFormData.name,
          email: popupFormData.email,
          phone: popupFormData.phone,
          message: popupFormData.message,
        },
        "popup-contact"
      );

      // Push to Google Analytics dataLayer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "form_submit_success"
      });

      setPopupFeedback({
        type: "success",
        message: "Thank you! Your message has been sent successfully.",
      });

      setPopupFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
      });

      setTimeout(() => {
        setShowPopup(false);
        setPopupFeedback({ type: "", message: "" });
      }, 2000);
    } catch (error) {
      console.error("Form submission error:", error);
      setPopupFeedback({
        type: "error",
        message: "An error occurred. Please try again.",
      });
    } finally {
      setPopupLoading(false);
    }
  };

  // Handle schedule visit form input changes
  const handleScheduleInputChange = (e) => {
    const { name, value } = e.target;
    setScheduleFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle schedule visit form submission
  const handleScheduleSubmit = async (e) => {
    e.preventDefault();
    setScheduleLoading(true);
    setScheduleFeedback({ type: "", message: "" });

    // Validate required fields
    const { isValid } = validateFormData(scheduleFormData, [
      "fullName",
      "email",
      "phone",
      "visitDate",
      "timeSlot",
    ]);

    if (
      !isValid ||
      !isValidEmail(scheduleFormData.email) ||
      !isValidPhone(scheduleFormData.phone)
    ) {
      setScheduleFeedback({
        type: "error",
        message:
          "Please fill all required fields correctly (valid email & 10-digit phone)",
      });
      setScheduleLoading(false);
      return;
    }

    try {
      const result = await submitToGoogleSheets(
        {
          fullName: scheduleFormData.fullName,
          email: scheduleFormData.email,
          phone: scheduleFormData.phone,
          visitDate: scheduleFormData.visitDate,
          timeSlot: scheduleFormData.timeSlot,
          requirements: scheduleFormData.requirements || "None",
        },
        "schedule-visit"
      );

      // Push to Google Analytics dataLayer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "form_submit_success"
      });

      setScheduleFeedback({
        type: "success",
        message:
          "Your visit has been scheduled! Our team will contact you soon.",
      });

      setScheduleFormData({
        fullName: "",
        email: "",
        phone: "",
        visitDate: "",
        timeSlot: "",
        requirements: "",
      });

      setTimeout(() => {
        setScheduleFeedback({ type: "", message: "" });
      }, 5000);
    } catch (error) {
      console.error("Form submission error:", error);
      setScheduleFeedback({
        type: "error",
        message: "An error occurred. Please try again.",
      });
    } finally {
      setScheduleLoading(false);
    }
  };

  return (
    <>
      {/* ================= HERO ================= */}
      <section className="group relative min-h-[480px] sm:min-h-[600px] flex items-center justify-center overflow-hidden">
        {/* VIDEO BACKGROUND */}
        <div className="absolute inset-0">
          <video
            className="w-full h-full object-cover blur-[0.5px] sm:blur-[1px]"
            src={heroVideo}
            autoPlay
            muted
            loop
            playsInline
          />

          {/* LIGHT OVERLAY */}
          <div className="absolute inset-0 bg-white/30 backdrop-blur-sm" />
        </div>

        {/* CONTENT */}
        <div className="relative z-10 text-center px-4 sm:px-6">
          {/* TITLE BLOCK */}
          <div className="animate-fadeUp">
            <h1
              className="
          text-2xl sm:text-4xl lg:text-7xl
    font-extrabold
    tracking-tight sm:tracking-wider
    text-[#8B2C3F]
    hero-outline
    mb-2
    transition-all duration-500
    group-hover:scale-[1.02]
    group-hover:text-[#8B2C3F]
        "
            >
              Welcome To Aduri Group
            </h1>

            {/* UNDERLINE WITH CENTER TEXT */}
            <div className="flex items-center justify-center gap-2 sm:gap-4 mb-6 flex-wrap">
              <span
                className="h-[2px] w-14 sm:w-28 bg-[#A63A50] transition-all duration-500
    group-hover:w-20 sm:group-hover:w-36"
              />

              <span className="text-white text-[10px] sm:text-sm lg:text-base font-medium tracking-wide text-center px-2">
                Most Trusted Real Estate Company In Telangana
              </span>

              <span
                className="h-[2px] w-14 sm:w-28 bg-[#A63A50] transition-all duration-500
    group-hover:w-20 sm:group-hover:w-36"
              />
            </div>
          </div>

          {/* SUB CONTENT */}
          <div className="max-w-3xl mx-auto animate-fadeUp delay-200">
            <h2 className="text-sm sm:text-lg lg:text-2xl font-medium text-[#1F3A45] mb-4 leading-snug">
              Building Trusted Landmarks. Creating Future-Ready Communities.
            </h2>

            <p className="text-xs sm:text-base lg:text-lg font-medium text-white mb-6 leading-relaxed">
              ✔ Open Plots &nbsp;|&nbsp; ✔ Farm Land Plots &nbsp;|&nbsp; ✔
              Wellness Townships
              <br className="hidden sm:block" />✔ Highway-Facing Projects
              &nbsp;|&nbsp; ✔ Ideal for Investment & Construction
            </p>

            {/* BUTTONS */}
            <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4 animate-fadeUp delay-400">
              <button
                onClick={() =>
                  document
                    .getElementById("premium-projects")
                    ?.scrollIntoView({ behavior: "smooth" })
                }
                className="
            bg-[#A63A50]
            text-white
            px-6 sm:px-7 py-2.5 sm:py-3
            rounded-md
            shadow-lg
            transition-all duration-300
            hover:shadow-[0_0_20px_rgba(31,58,69,0.45)]
            hover:-translate-y-0.5
          "
              >
                View Projects
              </button>

              <button
                onClick={() =>
                  document
                    .getElementById("site-visit")
                    ?.scrollIntoView({ behavior: "smooth" })
                }
                className="
            bg-white
            text-[#8B2C3F]
            border border-[#1f3a45]
            px-6 sm:px-7 py-2.5 sm:py-3
            rounded-md
            shadow-lg
            transition-all duration-300
            hover:bg-[#8B2C3F]
            hover:text-white
            hover:shadow-[0_0_20px_rgba(31,58,69,0.45)]
            hover:-translate-y-0.5
          "
              >
                contact us
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="pt-10 pb-10 bg-white">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          <div className="grid md:grid-cols-3 gap-12">
            {/* Feature 1 */}
            <div className="bg-slate-50 rounded-xl p-8">
              <div className="flex items-center gap-3 mb-4">
                <FaGem className="text-primary text-lg" />
                <h3 className="text-lg font-bold text-primaryDark">
                  Legally Approved Projects
                </h3>
              </div>
              <p className="text-slate-600 leading-relaxed">
                DTCP / MUDA / RERA-approved layouts ensure complete peace of
                mind and secure investment.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="bg-slate-50 rounded-xl p-8">
              <div className="flex items-center gap-3 mb-4">
                <FaLocationArrow className="text-primary text-lg" />
                <h3 className="text-lg font-bold text-primaryDark">
                  Strategic Locations
                </h3>
              </div>
              <p className="text-slate-600 leading-relaxed">
                Projects located near highways, growth corridors, temples, IT &
                industrial hubs.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="bg-slate-50 rounded-xl p-8">
              <div className="flex items-center gap-3 mb-4">
                <FaChartLine className="text-primary text-lg" />
                <h3 className="text-lg font-bold text-primaryDark">
                  High ROI Potential
                </h3>
              </div>
              <p className="text-slate-600 leading-relaxed">
                Designed for long-term appreciation with infrastructure-ready
                development.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ================= EXPERIENCE ================= */}
      <section id="premium-projects" className="pt-10 pb-14 bg-stone-50">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          {/* Heading */}
          <div className="text-center max-w-3xl mx-auto mb-10">
            <h2 className="text-3xl md:text-4xl font-bold text-primary mb-3">
              Explore Our Premium Projects
            </h2>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed">
              Thoughtfully planned developments tailored for investors,
              families, and future homeowners.
            </p>
          </div>

          {/* Slider Wrapper */}
          <div className="relative">
            {/* LEFT ARROW */}
            <button
              onClick={() =>
                document.getElementById("experience-slider").scrollBy({
                  left: -300,
                  behavior: "smooth",
                })
              }
              className="
    absolute left-2 sm:-left-5
    top-1/2 -translate-y-1/2
    z-20
    bg-white shadow-md
    w-8 h-8 sm:w-10 sm:h-10
    rounded-full
    flex items-center justify-center
    text-primary text-lg sm:text-xl
  "
            >
              ‹
            </button>

            {/* RIGHT ARROW */}
            <button
              onClick={() =>
                document.getElementById("experience-slider").scrollBy({
                  left: 300,
                  behavior: "smooth",
                })
              }
              className="
    absolute right-2 sm:-right-5
    top-1/2 -translate-y-1/2
    z-20
    bg-white shadow-md
    w-8 h-8 sm:w-10 sm:h-10
    rounded-full
    flex items-center justify-center
    text-primary text-lg sm:text-xl
  "
            >
              ›
            </button>

            {/* Slider */}
            <div
              id="experience-slider"
              className="flex gap-6 overflow-x-auto scroll-smooth no-scrollbar pb-2"
            >
              {[
                {
                  img: livingImage,
                  title: "Aduri’s Golden Heights @ Rajapur",
                  subtitle: "Premium Open Plots | Near NH-44, Shadnagar",
                  desc: "DTCP & TS RERA Approved plotted development just 1 km from Hyderabad–Bangalore Highway.",
                  price: "Starting from ₹13,799 / sq. yd",
                  btn: "View Project",
                  path: "/projects/rajapur",
                },
                {
                  img: amenitiesImage,
                  title: "Golden Heights – Health Village, Shadnagar",
                  subtitle:
                    "75-Acre Wellness Township | Open Plots, Villas & Apartments",
                  desc: "A landmark health-focused gated community featuring Ayurveda & Wellness Hub,51+ lifestyle amenities, and future-ready infrastructure.",
                  price: "Starting from ₹20,299 / sq. yd",
                  btn: "View Project",
                  path: "/projects/shadnagar",
                },
                {
                  img: viewImage,
                  title: "Golden Heights – Budhera, Sadasivapet",
                  subtitle: "65-Acre DTCP Township | Mumbai NH-65",
                  desc: "Highway-facing mega residential township near IIT Hyderabad, SEZs & industrial hubs. Perfect for both end-use and long-term investment.",
                  price: "Starting from ₹20,299 / sq. yd",
                  btn: "View Project",
                  path: "/projects/sadasivapet",
                },
                {
                  img: lifestyleImage,
                  title: "Dream Valley – Nagulapally, Shadnagar",
                  subtitle:
                    "Premium Farm Plots Project near Shadnagar–Bengaluru Highway.",
                  desc: "100-acre premium farmland project with 2, 4 & 8 Gunta plots, fruit plantations, modern amenities, and a secure gated layout. Limited Plots Available",
                  price: "Starting from ₹13,299 / sq. yd",
                  btn: "View Project",
                  path: "/projects/dreamvalley",
                },
                {
                  img: livingImage2,
                  title: "Aduri’s Aabharana @ Yadadri",
                  subtitle: "DTCP-Approved Open Plots Near Yadadri Temple",
                  desc: "Construction-ready, Vaastu-compliant plots in a spiritually significant and fast-developing region near Hyderabad. Divine Living | Smart Investment",
                  price: "Starting from ₹12,500 / sq. yd",
                  btn: "View Project",
                  path: "/projects/aabharana",
                },
              ].map((item, i) => (
                <div
                  key={i}
                  className="min-w-[320px] bg-white rounded-2xl shadow-md flex flex-col"
                >
                  {/* Image */}
                  <img
                    src={item.img}
                    alt={item.title}
                    className="h-56 w-full object-cover"
                  />

                  {/* Content */}
                  <div className="p-5 text-center flex flex-col h-80">
                    <h3 className="text-base font-semibold text-primary mb-2">
                      {item.title}
                    </h3>

                    <p className="text-sm font-medium text-slate-700 mb-1">
                      {item.subtitle}
                    </p>

                    <p className="text-sm text-slate-600 leading-relaxed mb-1">
                      {item.desc}
                    </p>

                    <p className="text-sm font-semibold text-primary mb-0">
                      {item.price}
                    </p>

                    <button
                      onClick={() => navigate(item.path)}
                      className="mt-auto bg-primary text-white px-5 py-2 rounded-md text-sm font-medium hover:bg-primaryDark transition"
                    >
                      {item.btn}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* PROJECT GALLERY */}
      <section className="pt-10 pb-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          {/* Heading */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-primary mb-2">
              Project Gallery
            </h2>
            <p className="text-slate-600">
              Explore our project through these carefully curated visuals
            </p>
          </div>

          {/* Images Grid */}
          <div className="grid md:grid-cols-3 gap-8">
            {[
              { image: gallery1, label: "Private Poolside Relaxation Area" },
              {
                image: gallery2,
                label: "Central Swimming Pool & Outdoor Amenities",
              },
              {
                image: gallery3,
                label: "Project Administrative & Utility Building",
              },
              { image: gallery4, label: "Outdoor Community Seating Area" },
              {
                image: gallery5,
                label: "Grand Entrance & Landscaped Driveway",
              },
              { image: gallery6, label: "Recreational Pool & Leisure Zone" },
            ].map((item, index) => (
              <div key={index}>
                <div className="overflow-hidden rounded-lg">
                  <img
                    src={item.image}
                    alt={item.label}
                    className="w-full h-56 object-cover hover:scale-105 transition duration-500"
                  />
                </div>
                <p className="mt-3 text-sm text-slate-600">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= OUR STRENGTHS ================= */}
      <section className="pt-10 pb-10 bg-[#f2f2f1]">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          {/* Heading */}
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-bold text-primary mb-4">
              OUR STRENGTHS
            </h2>

            <div className="flex items-center justify-center gap-4">
              <span className="h-px w-16 md:w-20 bg-primary/40"></span>
              <FaLeaf className="text-emerald-500 text-lg md:text-xl" />
              <span className="h-px w-16 md:w-20 bg-primary/40"></span>
            </div>
          </div>

          {/* Strength Cards */}
          <div
            className="
    flex gap-4
    overflow-x-auto
    snap-x snap-mandatory
    pb-4

    lg:grid lg:grid-cols-5
    lg:gap-6
    lg:overflow-visible
    lg:snap-none
  "
          >
            {[strength1, strength2, strength3, strength4, strength5].map(
              (img, index) => (
                <div
                  key={index}
                  className="
          snap-center
          flex-shrink-0

          bg-[#f2f2f1]
          border-2 border-primary
          rounded-[24px]
          shadow-[0_8px_16px_rgba(0,0,0,0.3)]
          p-4 md:p-6

          w-[220px] sm:w-[240px] md:w-[260px]
          h-[100px] sm:h-[110px] md:h-[120px]

          lg:w-auto
          lg:h-[130px]

          flex items-center justify-center
          transition-all duration-300
          hover:scale-105
          hover:shadow-[0_16px_28px_rgba(0,0,0,0.45)]
        "
                >
                  <img
                    src={img}
                    alt="Our Strength"
                    className="
            h-[60px]
            sm:h-[70px]
            md:h-[90px]
            lg:h-[110px]
            w-auto
            object-contain
          "
                  />
                </div>
              )
            )}
          </div>
        </div>
      </section>

      {/* ================= TESTIMONIALS ================= */}
      <section className="pt-10 pb-10 bg-slate-50">
        <div className="max-w-6xl mx-auto px-6">
          {/* Heading */}
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              What Our Clients Say
            </h2>
            <p className="text-slate-600 text-sm md:text-base">
              Discover why our clients trust us with their real estate
              investment decisions
            </p>
          </div>

          {/* ===== ROW 1 : 3 TESTIMONIALS ===== */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-14">
            {/* Testimonial 1 */}
            <div className="bg-white rounded-xl p-6 shadow-sm text-center space-y-5">
              <p className="text-slate-600 italic leading-relaxed text-sm">
                “The amenities in this project are exceptional. The landscaped
                gardens and clubhouse exceeded my expectations.”
              </p>
              <div className="flex items-center justify-center gap-3">
                <img
                  src={man2}
                  alt="Rajesh Kumar"
                  className="h-10 w-10 rounded-full"
                />
                <div className="text-left">
                  <p className="font-semibold text-sm">Rajesh Kumar</p>
                  <p className="text-xs text-slate-500">
                    Business Owner, Hyderabad
                  </p>
                </div>
              </div>
            </div>

            {/* Testimonial 2 (highlight) */}
            <div className="bg-sky-100 rounded-xl p-8 shadow-sm text-center space-y-5">
              <p className="text-slate-700 italic leading-relaxed text-sm">
                “The location is perfect for my family—close to schools,
                hospitals, and shopping centers. Truly worth every rupee!”
              </p>
              <div className="flex items-center justify-center gap-3">
                <img
                  src={woman1}
                  alt="Priya Sharma"
                  className="h-12 w-12 rounded-full"
                />
                <div className="text-left">
                  <p className="font-semibold text-sm">Priya Sharma</p>
                  <p className="text-xs text-slate-500">
                    IT Professional, Bangalore
                  </p>
                </div>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="bg-white rounded-xl p-6 shadow-sm text-center space-y-5">
              <p className="text-slate-600 italic leading-relaxed text-sm">
                “As a first-time homebuyer, the team guided me through every
                step. The experience was smooth and transparent.”
              </p>
              <div className="flex items-center justify-center gap-3">
                <img
                  src="https://images.unsplash.com/photo-1595152772835-219674b2a8a6"
                  alt="Vikram Reddy"
                  className="h-10 w-10 rounded-full"
                />
                <div className="text-left">
                  <p className="font-semibold text-sm">Vikram Reddy</p>
                  <p className="text-xs text-slate-500">
                    Software Engineer, Hyderabad
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* ===== ROW 2 : 2 TESTIMONIALS (CENTERED) ===== */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-4xl mx-auto">
            {/* Testimonial 4 */}
            <div className="bg-white rounded-xl p-6 shadow-sm text-center space-y-5">
              <p className="text-slate-600 italic leading-relaxed text-sm">
                “The gated community provides excellent security and facilities.
                My children love the play areas and open spaces.”
              </p>
              <div className="flex items-center justify-center gap-3">
                <img
                  src={woman2}
                  alt="Sunita Patel"
                  className="h-10 w-10 rounded-full"
                />
                <div className="text-left">
                  <p className="font-semibold text-sm">Sunita Patel</p>
                  <p className="text-xs text-slate-500">Entrepreneur, Mumbai</p>
                </div>
              </div>
            </div>

            {/* Testimonial 5 */}
            <div className="bg-white rounded-xl p-6 shadow-sm text-center space-y-5">
              <p className="text-slate-600 italic leading-relaxed text-sm">
                “I purchased this property as an investment and the returns have
                been impressive. Maintenance services are prompt and reliable.”
              </p>
              <div className="flex items-center justify-center gap-3">
                <img
                  src={man1}
                  alt="Anand Verma"
                  className="h-10 w-10 rounded-full"
                />
                <div className="text-left">
                  <p className="font-semibold text-sm">Anand Verma</p>
                  <p className="text-xs text-slate-500">
                    Retired Banker, Chennai
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* OVERALL CUSTOMER SATISFACTION */}
      <section className="pt-10 pb-10 bg-white">
        <div className="max-w-7xl mx-auto px-4 lg:px-8">
          {/* Rating */}
          <div className="text-center mb-16">
            <h3 className="text-2xl font-bold text-slate-900 mb-3">
              Overall Customer Satisfaction
            </h3>

            <div className="flex items-center justify-center gap-2 text-primary text-xl mb-2">
              ★★★★☆
              <span className="text-slate-900 text-base font-semibold ml-2">
                4.8/5
              </span>
            </div>

            <p className="text-slate-600 text-sm">
              Based on 128 verified customer reviews
            </p>
          </div>

          {/* Stats */}
          <div className="grid md:grid-cols-3 gap-8 bg-slate-100 rounded-xl py-10 px-6 text-center">
            <div>
              <p className="text-3xl font-bold text-primary mb-2">96%</p>
              <p className="text-slate-600 text-sm">
                Would recommend to friends & family
              </p>
            </div>

            <div>
              <p className="text-3xl font-bold text-primary mb-2">92%</p>
              <p className="text-slate-600 text-sm">
                Satisfied with construction quality
              </p>
            </div>

            <div>
              <p className="text-3xl font-bold text-primary mb-2">98%</p>
              <p className="text-slate-600 text-sm">
                Happy with location & connectivity
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BOOK A SITE VISIT */}
      <section id="site-visit" className="pt-10 pb-10 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 space-y-16">
          {/* TOP BANNER */}
          <div className="relative h-[380px] rounded-2xl overflow-hidden">
            <img
              src={bannerImage}
              alt="Book Site Visit"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/60" />

            <div className="relative z-10 h-full flex flex-col items-center justify-center text-center text-white px-6">
              <h2 className="text-3xl md:text-4xl font-bold mb-4">
                Book a Site Visit Today
              </h2>

              <p className="max-w-2xl text-gray-200 mb-8">
                Experience our premium properties firsthand and discover your
                dream home with a personalized guided tour.
              </p>

              <div className="flex flex-wrap gap-4 justify-center">
                <a
                  href="tel:+918374249705"
                  className="bg-primary px-6 py-3 rounded-md font-medium shadow inline-block text-white"
                >
                  Call Now
                </a>

                <a
                  href="https://wa.me/918331905506"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-emerald-600 px-6 py-3 rounded-md font-medium shadow inline-block text-white"
                >
                  WhatsApp Now
                </a>
                <button
                  onClick={() => navigate("/contact")}
                  className="bg-white text-primary px-6 py-3 rounded-md font-medium shadow"
                >
                  Enquire Now
                </button>
              </div>
            </div>
          </div>

          {/* ================= FORM + INFO ================= */}
          <div className="bg-slate-50">
            <div className="max-w-6xl mx-auto px-6">
              <div className="flex justify-center">
                <div className="grid lg:grid-cols-2 gap-10 max-w-5xl w-full items-start">
                  {/* ================= LEFT : SCHEDULE FORM ================= */}
                  <div className="bg-white rounded-xl shadow-sm p-8 w-full">
                    <h3 className="text-xl font-bold text-slate-900 mb-6">
                      Schedule Your Visit
                    </h3>

                    {scheduleFeedback.message && (
                      <div
                        className={`mb-6 p-4 rounded-md text-sm font-medium ${
                          scheduleFeedback.type === "success"
                            ? "bg-green-100 text-green-800 border border-green-300"
                            : "bg-red-100 text-red-800 border border-red-300"
                        }`}
                      >
                        {scheduleFeedback.message}
                      </div>
                    )}

                    <form className="space-y-4" onSubmit={handleScheduleSubmit}>
                      <div>
                        <label className="block text-sm font-medium mb-1">
                          Full Name <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          name="fullName"
                          value={scheduleFormData.fullName}
                          onChange={handleScheduleInputChange}
                          placeholder="Enter your full name"
                          className="w-full border rounded-md px-4 py-3 text-sm focus:ring-2 focus:ring-primary outline-none"
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-medium mb-1">
                          Email Address <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="email"
                          name="email"
                          value={scheduleFormData.email}
                          onChange={handleScheduleInputChange}
                          placeholder="Enter your email address"
                          className="w-full border rounded-md px-4 py-3 text-sm focus:ring-2 focus:ring-primary outline-none"
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-medium mb-1">
                          Phone Number <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="tel"
                          name="phone"
                          value={scheduleFormData.phone}
                          onChange={handleScheduleInputChange}
                          placeholder="Enter your phone number"
                          className="w-full border rounded-md px-4 py-3 text-sm focus:ring-2 focus:ring-primary outline-none"
                        />
                      </div>

                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <label className="block text-sm font-medium mb-1">
                            Preferred Visit Date{" "}
                            <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="date"
                            name="visitDate"
                            value={scheduleFormData.visitDate}
                            onChange={handleScheduleInputChange}
                            className="w-full border rounded-md px-4 py-3 text-sm focus:ring-2 focus:ring-primary outline-none"
                          />
                        </div>

                        <div>
                          <label className="block text-sm font-medium mb-1">
                            Preferred Time Slot{" "}
                            <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="time"
                            name="timeSlot"
                            value={scheduleFormData.timeSlot}
                            onChange={handleScheduleInputChange}
                            className="w-full border rounded-md px-4 py-3 text-sm focus:ring-2 focus:ring-primary outline-none"
                          />
                        </div>
                      </div>

                      <div>
                        <label className="block text-sm font-medium mb-1">
                          Additional Requirements
                        </label>
                        <textarea
                          rows="5"
                          name="requirements"
                          value={scheduleFormData.requirements}
                          onChange={handleScheduleInputChange}
                          placeholder="Any specific requirements or questions"
                          className="w-full border rounded-md px-4 py-3 text-sm focus:ring-2 focus:ring-primary outline-none"
                        />
                      </div>

                      <button
                        type="submit"
                        disabled={scheduleLoading}
                        className="w-full bg-primary text-white py-3 rounded-md font-medium hover:bg-primaryDark transition disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        {scheduleLoading ? "Submitting..." : "Submit Request"}
                      </button>
                    </form>
                  </div>

                  {/* ================= RIGHT : INFO BOXES ================= */}
                  <div className="space-y-6 w-full">
                    {/* WHY VISIT */}
                    <div className="bg-sky-100 rounded-2xl p-6">
                      <h4 className="text-lg font-bold text-slate-800 mb-4">
                        Why Visit Our Project?
                      </h4>

                      <ul className="space-y-4">
                        {[
                          [
                            "Experience the Luxury",
                            "Walk through premium spaces and quality craftsmanship.",
                          ],
                          [
                            "Explore the Amenities",
                            "World-class amenities designed for modern living.",
                          ],
                          [
                            "Meet Our Experts",
                            "Get all your questions answered during your visit.",
                          ],
                          [
                            "Special Offers",
                            "Exclusive site-visit offers available to visitors.",
                          ],
                        ].map(([title, desc], i) => (
                          <li key={i} className="flex gap-3">
                            <span className="text-primary mt-0.5">✔</span>
                            <div>
                              <p className="font-semibold text-sm text-slate-800">
                                {title}
                              </p>
                              <p className="text-sm text-slate-600 leading-snug">
                                {desc}
                              </p>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* CONTACT INFO */}
                    {/* CONTACT INFO */}
                    <div className="bg-white rounded-2xl p-6 border">
                      <h4 className="text-lg font-bold text-slate-800 mb-4">
                        Contact Information
                      </h4>

                      <ul className="space-y-4 text-sm text-slate-700">
                        {/* Corporate Office */}
                        <li className="flex gap-3">
                          📍
                          <a
                            href="https://www.google.com/maps?q=3rd%20Floor,%20Plot%20No.%2014,%20Lodha%20Road,%205th%20Phase,%20KPHB,%20Hyderabad"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:underline hover:text-primary transition"
                          >
                            <strong>Corporate Office – KPHB: </strong>
                            3rd Floor, Plot No. 14, Lodha Road, 5th Phase, KPHB,
                            Hyderabad – 72
                          </a>
                        </li>

                        {/* Banjara Hills */}
                        <li className="flex gap-3">
                          📍
                          <a
                            href="https://www.google.com/maps?q=Plot%20No.%2077/4,%202nd%20Floor,%20MB%20Towers,%20Road%20No.%2010,%20Banjara%20Hills,%20Hyderabad"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:underline hover:text-primary transition"
                          >
                            <strong>Banjara Hills Branch: </strong>
                            Plot No. 77/4, 2nd Floor, MB Towers, Road No. 10,
                            Banjara Hills, Hyderabad – 34
                          </a>
                        </li>

                        {/* LB Nagar */}
                        <li className="flex gap-3">
                          📍
                          <a
                            href="https://www.google.com/maps?q=Plot%20No.%206,%20H%20No.%203-4-242,%20Srikari%20Heights,%20SBH%20Colony,%20L.B.%20Nagar,%20Hyderabad"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:underline hover:text-primary transition"
                          >
                            <strong>L.B. Nagar Branch: </strong>
                            Plot No. 6, H No. 3-4-242, Srikari Heights, SBH
                            Colony, L.B. Nagar Metro Station, L.B. Nagar,
                            Hyderabad – 74
                          </a>
                        </li>

                        {/* Phone */}
                        <li className="flex gap-3">
                          📞
                          <a
                            href="tel:+918374249705"
                            className="hover:text-primary transition"
                          >
                            +91 83742 49705
                          </a>
                          ,
                          <a
                            href="tel:+918331905506"
                            className="hover:text-primary transition ml-1"
                          >
                            +91 83319 05506
                          </a>
                        </li>

                        {/* Email */}
                        <li className="flex gap-3">
                          ✉️
                          <a
                            href="mailto:rameshgadhamv6@gmail.com"
                            className="hover:text-primary transition"
                          >
                            rameshgadhamv6@gmail.com
                          </a>
                        </li>

                        {/* Timings */}
                        <li className="flex gap-3">
                          🕒
                          <span>Mon – Sat: 8:00 AM – 6:00 PM</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ================= MAP SECTION ================= */}
          <section className="bg-white rounded-xl p-6 shadow-sm mb-20">
            <h3 className="text-center text-2xl font-bold text-primary mb-10">
              Our Office Locations
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* Corporate Office – KPHB */}
              <div>
                <h4 className="text-center font-semibold mb-4">
                  Corporate Office – KPHB
                </h4>

                <div className="h-[260px] rounded-lg overflow-hidden border">
                  <iframe
                    title="Corporate Office KPHB"
                    src="https://www.google.com/maps?q=Aduri%20Infra%20Pvt%20Ltd,%20KPHB%205th%20Phase,%20Hyderabad&output=embed"
                    className="w-full h-full border-0"
                    loading="lazy"
                  />
                </div>

                <div className="text-center mt-4">
                  <a
                    href="https://www.google.com/maps/dir/?api=1&destination=3rd%20Floor,%20Plot%20No.%2014,%20Lodha%20Road,%205th%20Phase,%20KPHB,%20Hyderabad"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-primary font-medium hover:underline"
                  >
                    View on Google Maps
                  </a>
                </div>
              </div>

              {/* Banjara Hills Branch */}
              <div>
                <h4 className="text-center font-semibold mb-4">
                  Banjara Hills Branch
                </h4>

                <div className="h-[260px] rounded-lg overflow-hidden border">
                  <iframe
                    title="Banjara Hills Branch"
                    src="https://www.google.com/maps?q=Aduri%20Group%20Banjara%20Hills%20Branch,%20Road%20No%2010,%20Hyderabad&output=embed"
                    className="w-full h-full border-0"
                    loading="lazy"
                  />
                </div>

                <div className="text-center mt-4">
                  <a
                    href="https://www.google.com/maps/dir/?api=1&destination=Plot%20No.%2077/4,%202nd%20Floor,%20MB%20Towers,%20Road%20No.%2010,%20Banjara%20Hills,%20Hyderabad"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-primary font-medium hover:underline"
                  >
                    View on Google Maps
                  </a>
                </div>
              </div>

              {/* LB Nagar Branch */}
              <div>
                <h4 className="text-center font-semibold mb-4">
                  L.B. Nagar Branch
                </h4>

                <div className="h-[260px] rounded-lg overflow-hidden border">
                  <iframe
                    title="LB Nagar Branch"
                    src="https://www.google.com/maps?q=Plot%20No.%206,%20H%20No.%203-4-242,%20Srikari%20Heights,%20SBH%20Colony,%20L.B.%20Nagar,%20Hyderabad&output=embed"
                    className="w-full h-full border-0"
                    loading="lazy"
                  />
                </div>

                <div className="text-center mt-4">
                  <a
                    href="https://www.google.com/maps/dir/?api=1&destination=Plot%20No.%206,%20H%20No.%203-4-242,%20Srikari%20Heights,%20SBH%20Colony,%20L.B.%20Nagar,%20Hyderabad"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-primary font-medium hover:underline"
                  >
                    View on Google Maps
                  </a>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>

      {/* CTA */}
      <section className="pt-10 pb-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
            Ready to Invest with Confidence?
          </h2>

          <p className="text-slate-600 text-lg mb-10">
            Whether you’re looking for high-return investments,
            construction-ready plots, or wellness-focused living, Aduri Group
            has the perfect project for you. <br />
            Site Visits Available | Bank Loan Assistance | Limited Inventory
          </p>

          <div className="flex justify-center gap-5">
            <button
              onClick={() => navigate("/contact")}
              className="bg-primary hover:bg-primaryDark text-white px-8 py-3.5 rounded-md font-medium shadow transition"
            >
              Get Pricing
            </button>

            <button
              onClick={() => {
                document
                  .getElementById("site-visit")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
              className="border border-primary text-primary px-8 py-3.5 rounded-md font-medium hover:bg-slate-50 transition"
            >
              Book Site Visit
            </button>
          </div>
        </div>
      </section>

      {showPopup && (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/60 px-4">
          <div className="relative w-full max-w-md bg-white rounded-xl shadow-2xl p-6">
            {/* Quick Contact Buttons - Top of Form */}
            <div className="mb-6 flex gap-3">
              {/* WhatsApp Button */}
              <button
                onClick={() => {
                  window.open(
                    "https://wa.me/918374249705?text=Hi%20I%20am%20interested%20in%20your%20projects",
                    "_blank"
                  );
                }}
                className="
            flex-1 
            bg-green-500
            text-white
            p-3
            rounded-lg
            shadow-md
            hover:shadow-[0_0_15px_rgba(34,197,94,0.5)]
            hover:bg-green-600
            transition-all duration-300
            flex items-center justify-center gap-2
            font-medium text-sm
          "
                aria-label="Chat on WhatsApp"
              >
                <FaComments size={18} />
                WhatsApp
              </button>

              {/* Call Button */}
              <button
                onClick={() => {
                  window.location.href = "tel:+918374249705";
                }}
                className="
            flex-1
            bg-blue-500
            text-white
            p-3
            rounded-lg
            shadow-md
            hover:shadow-[0_0_15px_rgba(59,130,246,0.5)]
            hover:bg-blue-600
            transition-all duration-300
            flex items-center justify-center gap-2
            font-medium text-sm
          "
                aria-label="Call us"
              >
                <FaPhoneAlt size={18} />
                Call
              </button>
            </div>

            <h2 className="text-xl font-bold text-primary mb-4">
              Send us a Message
            </h2>

            {popupFeedback.message && (
              <div
                className={`mb-4 p-3 rounded-md text-sm font-medium ${
                  popupFeedback.type === "success"
                    ? "bg-green-100 text-green-800 border border-green-300"
                    : "bg-red-100 text-red-800 border border-red-300"
                }`}
              >
                {popupFeedback.message}
              </div>
            )}

            <form onSubmit={handlePopupSubmit} className="space-y-3">
              <input
                type="text"
                name="name"
                value={popupFormData.name}
                onChange={handlePopupInputChange}
                placeholder="Your Name"
                className="w-full border rounded-md px-3 py-2 mb-3"
              />

              <input
                type="email"
                name="email"
                value={popupFormData.email}
                onChange={handlePopupInputChange}
                placeholder="Email"
                className="w-full border rounded-md px-3 py-2 mb-3"
              />

              <input
                type="tel"
                name="phone"
                value={popupFormData.phone}
                onChange={handlePopupInputChange}
                placeholder="Phone"
                className="w-full border rounded-md px-3 py-2 mb-3"
              />

              <textarea
                name="message"
                value={popupFormData.message}
                onChange={handlePopupInputChange}
                placeholder="Message"
                className="w-full border rounded-md px-3 py-2 mb-4"
              />

              <button
                type="submit"
                disabled={popupLoading}
                className="w-full bg-primary text-white py-2 rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {popupLoading ? "Sending..." : "Send Message"}
              </button>
            </form>

            <button
              onClick={() => setShowPopup(false)}
              className="absolute top-2 right-3 text-xl text-gray-500"
            >
              ✕
            </button>
          </div>
        </div>
      )}

      {/* FLOATING CONTACT ICON - Main Button */}
      <button
        onClick={() => setShowFloatingButtons(!showFloatingButtons)}
        className="
    fixed bottom-6 right-6
    bg-primary
    text-white
    p-4
    rounded-full
    shadow-lg
    transition-all duration-300

    flex items-center justify-center
    z-[9999]
    hover:scale-110
  "
        aria-label="Open Contact Options"
      >
        <FaComments size={22} />
      </button>

      {/* FLOATING BUTTONS - WhatsApp and Call Options */}
      {showFloatingButtons && (
        <>
          {/* WhatsApp Button */}
          <a
            href="https://wa.me/918374249705?text=Hi%20I%20am%20interested%20in%20your%20projects"
            target="_blank"
            rel="noopener noreferrer"
            className="
        fixed bottom-24 right-6
        bg-green-500
        text-white
        p-4
        rounded-full
        shadow-lg
        hover:shadow-[0_0_25px_rgba(34,197,94,0.7)]
        transition-all duration-300
        flex items-center justify-center
        z-[9998]
        hover:scale-110
      "
            aria-label="Chat on WhatsApp"
          >
            <FaComments size={22} />
          </a>

          {/* Call Button */}
          <a
            href="tel:+918374249705"
            className="
        fixed bottom-40 right-6
        bg-red-900
        text-white
        p-4
        rounded-full
        shadow-lg
        hover:shadow-[0_0_25px_rgba(139,44,63,0.7)]
        transition-all duration-300
        flex items-center justify-center
        z-[9998]
        hover:scale-110
      "
            aria-label="Call Now"
          >
            <FaPhoneAlt size={22} />
          </a>
        </>
      )}
    </>
  );
};

export default Home;
